<template>
  <div class="item">
    <div class="field-narrow">{{ index + 1 }}</div>
    <div class="field-medium">{{ item.operation_type }}</div>
    <div class="field-medium" v-if="item.operation_type !== 'LOGIN'">{{ item.table_name }}</div>
    <div class="field-medium" v-else>{{ t('none') }}</div>
    <div class="field-medium" v-if="item.operation_type === 'LOGIN'">{{ item.table_name }}</div>
    <div class="field-medium" v-else>{{ item.user_name }}</div>
    <div class="field-medium">{{ convertGMT0toGMT8(item.operation_time) }}</div>
    <div class="field-medium" v-if="item.id > 0">
      <button type="button" @click="viewItem" class="btn">{{ $t('information') }}</button>
    </div>
    <div class="field-medium" v-else />
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n';
import { inject } from 'vue';
import { checkPages, convertGMT0toGMT8 } from '../utils/stringValid';

export default {
  props: {
    index: {
      type: Number,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { t } = useI18n();
    const apiBaseUrl = inject('apiBaseUrl');
    const url = 'audit';
    return { t, apiBaseUrl, url };
  },
  methods: {
    convertGMT0toGMT8,
    checkPages,
    viewItem() {
      this.$router.push(`/${this.url}/${this.item.id}`);
    },
  },
};
</script>

<style>
.item {
  display: flex;
  justify-content: space-between;
  font-weight: normal;
  padding: 10px;
}

.field-narrow {
  flex: 1;
  text-align: center;
}

.field-medium {
  flex: 2;
  text-align: center;
}
</style>
